import React from "react";
import Tag from "../../../../generic/tag";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsDsk.scss";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsTab.scss";
import { ChipColorKeyComb } from "../../obConstants";

export interface ObAssetsDetlProps {
	date: string;
	trsTyp: string;
	title: string;
	sts: string;
}

const ObAssetsDetl: React.FC<ObAssetsDetlProps> = (props) => {
	return (
		<div className="ob_ast_detls_con">
			<h3 className="date">{props.date}</h3>
			<div>
				<div className="tag_con ib">
					<Tag value={props.trsTyp} shape="circle" color={props.trsTyp === "BUY" ? "green" : "red"} height="60px" width="60px" />
				</div>
				<div className="comp_detail ib">
					<h2 className="title dtl_tit">{props.title}</h2>
				</div>
				<div className="sts_cont ib">
					<span className="sts">Status</span>
					<Tag value={props.sts} shape="chip" color={ChipColorKeyComb[props.sts]} />
				</div>
			</div>
		</div>
	);
};

export default ObAssetsDetl;
